import { FC } from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Outlet, useNavigate } from 'react-router-dom';

const GlobalError: FC<FallbackProps> = ({ resetErrorBoundary }) => {
  const navigate = useNavigate();

  return (
    <VStack justify="center" position="absolute" inset="0" h="100vh">
      <Heading fontSize="3xl" fontWeight="bold" color="custom_orange.2">
        Something went wrong
      </Heading>
      <Box
        as="button"
        onClick={() => {
          navigate('/');
          resetErrorBoundary();
        }}
      >
        <Text color="custom_orange.2">Go to home</Text>
      </Box>
    </VStack>
  );
};

export const ErrorBoundaryLayout = () => (
  <ErrorBoundary FallbackComponent={GlobalError}>
    <Outlet />
  </ErrorBoundary>
);
